import { render, staticRenderFns } from "./VDealBlocker.vue?vue&type=template&id=5fb5f5dd"
import script from "./VDealBlocker.vue?vue&type=script&lang=js"
export * from "./VDealBlocker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports